import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Routing from "./route/routing";
import AOS from "aos";
import "aos/dist/aos.css";
import axiosInstance from "./utils/axios";
import { Provider } from "react-redux";
import store from "./reduxReducers/configureStore";

axiosInstance.initialize();

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routing />
      </BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
    </Provider>
  );
};

export default App;
